import slugify from 'slugify';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import { getIsAndroid, getIsCordova, getIsIOS } from '@bridebook/web/lib/mobile-app/selectors';
import { getPrefNumber } from '@bridebook/web/lib/mobile-app/utils/preferences-wrapper';
import { ITrackEventAction } from '@bridebook/web/lib/track-utils/actions';
import { TrackingEvent } from '@bridebook/web/lib/track-utils/tracking-event';
import { IApplicationState } from '@bridebook/web/lib/types';

const isSendEnquiryAction = (
  action: ITrackEventAction<any>,
): action is ITrackEventAction<IUISupplier> =>
  action.event === TrackingEvent.SendEnquiry &&
  action.payload !== undefined &&
  'type' in action.payload;

export const isRelevantAction = (action: ITrackEventAction<any>): boolean =>
  !(isSendEnquiryAction(action) && action.payload?.type !== 'venue');

export const isTrackable = async ([action, state]: [
  ITrackEventAction<unknown>,
  IApplicationState,
]) => {
  const isIos = getIsIOS(state);
  const isCordova = getIsCordova(state);
  const isAndroid = getIsAndroid(state);
  const isMobileApp = isCordova && (isIos || isAndroid);
  if (!isMobileApp) {
    return false;
  }

  if (action.fireOnce) {
    const hasBeenFiredOnce = await getPrefNumber({ key: toPreferenceKey(action) });
    if (hasBeenFiredOnce) {
      return false;
    }
  }

  return true;
};

export const toPreferenceKey = (action: ITrackEventAction<unknown>) =>
  `_once_${slugify(action.event, { lower: true })}`;
